import React from "react"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import { Wrap } from "./productreferencetwo.styled"

const ProductReferenceTwo = ({ data }) => {
  const { heading, copy, image } = data
  return (
    <Wrap image={image}>
      <TextElementNova
        text={heading}
        classes={{
          default: "Body-10-Dia-Strong",
          768: "Body-10-Dia-Strong",
          1024: "Body-20-Dia-Strong",
        }}
      />
      <TextElementNova
        text={copy}
        className="text-nova-transparency-black-70"
        classes={{
          default: "Body-10-Dia-Normal",
          768: "Body-10-Dia-Normal",
          1024: "Body-20-Dia-Normal",
        }}
      />
    </Wrap>
  )
}

export default ProductReferenceTwo
